<template>
    <div class="container p-0">
        <el-row class="border room-type-container mb-3 pr-2" v-for="(roomType , index) in roomTypes" :key="roomType.id">
            <el-col class="col-sm-12 col-md-4 p-0 ">
                <el-image
                    @click="setDataForModal(['',roomType])"
                    style="width: 100%; max-height: 200px"
                    :src="roomType.first_image"
                    :fit="'fit'"/>
            </el-col>
            <el-col class="col-sm-12 col-md-8 ">
                <room-offer-component
                    :roomType="roomType"
                    :searchFieldValue="searchFieldValue"
                    :totalRooms="totalRooms"
                    v-on:personalPage="(val) => setPersonalPage(val)"
                    v-on:data="(val) => setData(val)"
                    v-on:roomOffer="(val) => setRoomOffer(val)"
                    v-on:roomTheme="(val) => setRoomTheme(val)"
                    v-on:dataForModal="(val) => setDataForModal(val)"
                    v-on:secondProgress="(val) => setSecondProgress(val)"
                />
            </el-col>
        </el-row>

        <el-dialog
            :title="selectedRoomType.name"
            :visible.sync="roomDialogVisible"
            width="60%">
            <div>
                <el-carousel height="400px">
                    <el-carousel-item v-for="(images,index) in singleRoomImages" :key="index" v-bind:class="{ 'active':index == 0 }">
                        <el-image
                            style="width: 100%; height: 100%"
                            :src="images"
                            :fit="'cover'"/>
                    </el-carousel-item>
                </el-carousel>
                <div>
                    <br>

                    <div>
                        <p >{{selectedRoomType.description}}</p>
                    </div>
                    <div v-if="selectedRoomOffer.room_rates">
                        <h6 class="orange">Room Notes</h6>
                        <label>Rates Include:</label>
                        <ul>
                            <li v-for="roomNotes in selectedRoomOffer.room_rates">{{roomNotes}}</li>
                        </ul>
                    </div>
                    <h6 class="orange">Maximum Room Capacity</h6>
                    <label><i v-if="selectedRoomType.max_room_capacity == 1" class="fas fa-user"></i><i v-if="selectedRoomType.max_room_capacity >= 2" class="fas fa-users"></i> {{selectedRoomType.max_room_capacity}} Peoples</label>
                    <h6 class="orange">Checkin Policy</h6>
                    <label>Check-in time: 14:00</label><br>
                    <label>  Check-out time: 12:00</label>
                    <h6 class="orange">Payment Policy</h6>
                    <label>Full prepayment at the time of booking. Payment made is non refundable.</label>
                    <h6 class="orange">Cancellation Policy</h6>
                    <label>No free cancellation is allowed for this rate, special conditions apply.</label><br>
                    <label>Changes or cancellations are not allowed for this rate.</label>
                </div>
                <h6 class="orange">Booking fees & taxes</h6>
                <hr>
                <b><h6>Service Charge</h6></b>
                <label>included</label>
                <hr class="mt-2">
                <b><h6>Service Charge</h6></b>
                <label>included</label>
                <br><br>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="roomDialogVisible = false">Ok</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import RoomOfferComponent from "./room_offer/RoomOfferComponent";
    export default {
        name: "FirstStepBookingComponent",
        components: {RoomOfferComponent},
        props : [
            'searchFieldValue',
            'searchFieldData',
        ],
        data(){
            return {
                roomDialogVisible:false,
                roomTypes:[],
                imagePath:'',
                personalPage:Boolean,
                capacityOffer:1,
                totalRooms:'',
                selectedRoomType:[],
                selectedRoomOffer:[],
                singleRoomImages:[],
            }
        },methods:{
            setPersonalPage : function (value) {
                this.personalPage = value;
            },
            setData : function (value) {
                this.$emit('data', value)
            },
            setRoomOffer : function (value) {
                this.$emit('roomOffer', value)
            },
            setRoomTheme : function (value) {
                this.$emit('roomTheme', value)
                // console.log(value)
            },
            setDataForModal : function (value) {
                this.roomDialogVisible = true;
                // console.log(value)
                $('#roomTypeModal').modal({
                    show: true
                });
                this.selectedRoomOffer = value[0];
                this.selectedRoomType = value[1];
                this.getSingleRoomImages();
            },
            getSingleRoomImages: function (roomType) {
                axios.post(`/singleRoomImage`,{
                    roomType:this.selectedRoomType.id
                })
                    .then(response => {
                        this.singleRoomImages = response.data;
                        // console.log(response.data)
                    });
            },
            setSecondProgress: function (value) {
                this.$emit('secondProgress', value)
            }
        },
        created() {
            axios.get(`/getAllRooms`)
            .then(response => {
                this.roomTypes = [...response.data]
                // console.log(this.roomTypes);
            })
            .catch(error => {
                // console.log(error)
            });

            axios.get(`/getAllRoomImages`)
            .then(response => {
                this.imagePath = response.data;
                // // console.log(this.imagePath[0])
            });
        },
        watch : {
            personalPage: function (newVal,oldVal) {
                this.$emit('personalPage', this.personalPage)
            },
        }
    }
</script>
<style scoped>
    @media (min-width: 768px ) {
        .room-type-container{
            /*height: 200px !important;*/
            /*overflow:hidden;*/
        }
    }

</style>
